import { useHistory } from 'react-router-dom'

export function useRedirect() {
    const history = useHistory()
    return {
        toLot(id: string) {
            history.push(`/lot/${id}`)
        },
        toOriginToken(id: string) {
            history.push(`/original-token/${id}`)
        },
        toIndex() {
            history.push('/')
        },
    }
}
